import React, {
    ReactElement, ReactNode, useContext, useMemo, useState,
} from "react";
import { SelectionState } from "./selection-state";
import useRouting from "../Routing";
import useKeyboardShortcuts, { useKeyboardState } from "../KeyboardShortcutContext";
import { useTheme } from "../Theme";

export const SelectionStateContext = React.createContext<SelectionState>(new SelectionState());

export function SelectionStateProvider({ children }: { children: ReactNode }): (ReactElement | null) {
    const keyboardState = useKeyboardState();
    const state = useMemo(() => new SelectionState(keyboardState), [keyboardState]);
    state.setRouting(useRouting());
    useKeyboardShortcuts(shortcuts => {
        state.register(shortcuts);
    });
    return (
        <SelectionStateContext.Provider value={state}>
            {children}
        </SelectionStateContext.Provider>
    );
}

export default function useSelectionState(): SelectionState {
    return useContext(SelectionStateContext);
}
